module.exports = __webpack_public_path__ + "static_pc/img/1.4437cb8d.jpg";